export const blogPosts = [
  {
    id: '1',
    slug: 'korean-kids-fashion-spring-2024',
    title: '2024春季中國童裝流行趨勢：清新色彩與舒適剪裁',
    excerpt: '探索2024年春季中國童裝的最新流行元素，從柔和的粉彩色系到寬鬆舒適的設計，讓孩子在時尚與舒適之間找到完美平衡。',
    content: `<p>隨著春天的到來，中國童裝市場迎來了全新的流行趨勢。2024年春季，設計師們將重點放在舒適性與美觀性的完美結合上。</p>

<h2>清新色彩主導</h2>
<p>今年春季最受歡迎的色彩包括薄荷綠、淡粉色、天空藍和奶油黃。這些柔和的色調不僅符合春天的氛圍，更能襯托出孩子們天真爛漫的氣質。</p>

<h2>舒適剪裁設計</h2>
<p>寬鬆的版型設計成為主流，讓孩子們在玩耍時更加自在。彈性面料的運用也越來越普遍，確保服裝既時尚又實用。</p>

<h2>環保材質選擇</h2>
<p>越來越多的中國童裝品牌開始使用有機棉和環保面料，這不僅對孩子的皮膚更友好，也體現了對環境的關注。</p>

<p>在JC Kids，我們精選了最新的中國童裝款式，讓您的孩子在這個春天成為最時尚的小明星。</p>`,
    image: 'https://public.readdy.ai/ai/img_res/d1b86d88064f94ad4e3b204f3e625fe4.jpg',
    date: '2024-03-15',
    category: '流行趨勢',
    tags: ['春季', '流行趨勢', '色彩搭配']
  },
  {
    id: '2',
    slug: 'how-to-choose-baby-clothes',
    title: '新手父母必讀：如何為寶寶選擇合適的衣服',
    excerpt: '為新生兒和嬰兒選擇衣服需要考慮多個因素。本文將為新手父母提供實用的選購指南，確保寶寶穿得舒適又安全。',
    content: `<p>為寶寶選擇衣服是每位新手父母都會面臨的挑戰。正確的選擇不僅關係到寶寶的舒適度，更影響到他們的健康成長。</p>

<h2>面料選擇最重要</h2>
<p>嬰兒的皮膚非常嬌嫩，建議選擇100%純棉或有機棉材質的衣服。這些天然面料透氣性好，不易引起過敏反應。</p>

<h2>尺寸要合適</h2>
<p>寶寶成長速度很快，但也不要買太大的衣服。過大的衣服可能會影響寶寶的活動，甚至造成安全隱患。建議選擇稍微寬鬆一點的尺寸。</p>

<h2>設計要簡單</h2>
<p>避免選擇有太多裝飾物的衣服，如珠子、亮片等，這些可能會被寶寶誤食。選擇開襟設計的衣服，方便穿脫和換尿布。</p>

<h2>顏色要安全</h2>
<p>選擇顏色較淺、染料較少的衣服，減少化學物質對寶寶皮膚的刺激。</p>

<p>在JC Kids，我們所有的嬰兒服裝都經過嚴格的質量檢測，確保每一件都適合您的寶寶。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Cute%20baby%20wearing%20soft%20organic%20cotton%20clothing%20in%20gentle%20pastel%20colors%20lying%20on%20a%20fluffy%20white%20blanket%20in%20a%20bright%20nursery%20room%20with%20natural%20sunlight%20and%20simple%20minimalist%20decor%20showcasing%20safe%20comfortable%20infant%20fashion&width=800&height=500&seq=blog2&orientation=landscape',
    date: '2024-03-10',
    category: '育兒知識',
    tags: ['嬰兒服裝', '選購指南', '新手父母']
  },
  {
    id: '3',
    slug: 'korean-school-uniform-style',
    title: '中式校園風：打造孩子的學院派穿搭',
    excerpt: '中國校園風格一直深受家長和孩子們的喜愛。了解如何為孩子打造既符合校規又時尚的穿搭風格。',
    content: `<p>中式校園風以其簡約、清新的特點，成為許多家長為孩子選擇日常穿搭的首選風格。</p>

<h2>經典元素運用</h2>
<p>白襯衫、針織背心、格子裙和西裝褲是中式校園風的經典單品。這些基礎款式可以自由搭配，創造出多種不同的造型。</p>

<h2>色彩搭配技巧</h2>
<p>以黑、白、灰、藏青色為主色調，搭配少量的紅色或綠色作為點綴。這種配色既顯得正式，又不失活潑。</p>

<h2>配件的重要性</h2>
<p>領結、領帶、髮飾等小配件能為整體造型加分。選擇質感好的配件，可以提升整體的精緻度。</p>

<h2>季節性調整</h2>
<p>春秋季可以選擇薄款針織衫，夏季選擇透氣的襯衫，冬季則搭配厚實的毛衣或外套。</p>

<p>JC Kids提供全系列的中式校園風服裝，讓您的孩子每天都能自信地上學。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Korean%20school%20children%20wearing%20classic%20preppy%20style%20uniforms%20with%20white%20shirts%20knit%20vests%20plaid%20skirts%20and%20navy%20blazers%20standing%20in%20a%20bright%20modern%20classroom%20with%20clean%20white%20walls%20and%20wooden%20desks%20showcasing%20elegant%20academic%20fashion&width=800&height=500&seq=blog3&orientation=landscape',
    date: '2024-03-05',
    category: '穿搭指南',
    tags: ['校園風', '穿搭技巧', '中式風格']
  },
  {
    id: '4',
    slug: 'summer-kids-fashion-tips',
    title: '夏日童裝選購秘訣：涼爽又時尚的穿搭方案',
    excerpt: '炎炎夏日，如何為孩子選擇既涼爽舒適又時尚美觀的服裝？本文分享實用的夏季童裝選購和搭配技巧。',
    content: `<p>夏天是孩子們最活躍的季節，選擇合適的服裝能讓他們玩得更開心、更舒適。</p>

<h2>面料選擇</h2>
<p>夏季童裝首選純棉、亞麻等天然透氣面料。這些材質吸汗性好，能快速排濕，讓孩子保持乾爽。</p>

<h2>款式設計</h2>
<p>選擇寬鬆的T恤、短褲、連衣裙等款式，避免過於緊身的設計。背心、吊帶裙等無袖款式也是不錯的選擇。</p>

<h2>顏色搭配</h2>
<p>淺色系服裝能反射陽光，降低體感溫度。白色、米色、淡藍色都是夏季的理想選擇。當然，鮮豔的色彩也能為夏日增添活力。</p>

<h2>防曬考量</h2>
<p>雖然要涼爽，但也要注意防曬。可以選擇輕薄的長袖防曬衣，或搭配帽子、太陽眼鏡等配件。</p>

<h2>易清洗特性</h2>
<p>夏天孩子容易出汗、弄髒衣服，選擇易清洗、快乾的面料能減輕家長的負擔。</p>

<p>在JC Kids，我們的夏季童裝系列結合了舒適性與時尚感，讓孩子們度過一個清爽的夏天。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Happy%20children%20wearing%20light%20breathable%20summer%20clothing%20in%20white%20cream%20and%20pastel%20colors%20playing%20outdoors%20in%20a%20sunny%20park%20with%20green%20grass%20and%20blue%20sky%20showcasing%20comfortable%20casual%20kids%20fashion%20with%20natural%20cotton%20fabrics&width=800&height=500&seq=blog4&orientation=landscape',
    date: '2024-02-28',
    category: '季節穿搭',
    tags: ['夏季', '選購技巧', '舒適穿搭']
  },
  {
    id: '5',
    slug: 'kids-clothing-care-guide',
    title: '童裝保養全攻略：延長衣服壽命的實用技巧',
    excerpt: '正確的保養方法能讓童裝保持如新，延長使用壽命。學習這些實用的洗滌和收納技巧，讓孩子的衣服更耐穿。',
    content: `<p>孩子的衣服雖然穿不了太久，但正確的保養方法仍然很重要，不僅能保持衣服的品質，還能傳給弟弟妹妹繼續穿。</p>

<h2>洗滌注意事項</h2>
<p>童裝建議使用溫和的洗衣液，避免使用漂白劑。深淺色衣物要分開洗，防止染色。新衣服第一次洗滌時可以加少許鹽，有助於固色。</p>

<h2>晾曬技巧</h2>
<p>盡量避免陽光直射，選擇通風陰涼處晾乾。深色衣物要反面晾曬，防止褪色。不要用力擰乾，輕輕擠壓去除多餘水分即可。</p>

<h2>熨燙方法</h2>
<p>如需熨燙，要根據面料選擇合適的溫度。棉質衣物可以高溫熨燙，但要在半乾時進行效果最好。有印花的衣服要反面熨燙。</p>

<h2>收納建議</h2>
<p>換季衣物要清洗乾淨後再收納，可以放入防蟲劑。使用真空袋可以節省空間，但要注意不要壓得太緊，以免變形。</p>

<h2>污漬處理</h2>
<p>發現污漬要及時處理，不同類型的污漬有不同的處理方法。油漬可用洗潔精，果汁漬可用白醋，墨水漬可用牛奶浸泡。</p>

<p>JC Kids的所有服裝都附有詳細的洗滌說明，請按照標籤指示進行保養。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20children%20clothing%20hanging%20on%20wooden%20hangers%20and%20folded%20in%20white%20storage%20baskets%20in%20a%20bright%20clean%20laundry%20room%20with%20natural%20light%20and%20minimalist%20decor%20showcasing%20proper%20garment%20care%20and%20organization&width=800&height=500&seq=blog5&orientation=landscape',
    date: '2024-02-20',
    category: '保養知識',
    tags: ['衣物保養', '洗滌技巧', '收納方法']
  }
];
